import { render, staticRenderFns } from "./mechanismTemplate.vue?vue&type=template&id=2ae8c36e&scoped=true"
import script from "./mechanismTemplate.vue?vue&type=script&lang=js"
export * from "./mechanismTemplate.vue?vue&type=script&lang=js"
import style0 from "./mechanismTemplate.vue?vue&type=style&index=0&id=2ae8c36e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae8c36e",
  null
  
)

export default component.exports